import { faClipboard } from "@fortawesome/pro-solid-svg-icons";

import { useCopyToClipboard } from "../../../hooks";
import { Icon, IconProps as IconPropsType } from "../Icon/Icon";
import { IconButton, IconButtonProps } from "../IconButton/IconButton";

interface CopyToClipboardProps extends Omit<IconButtonProps, "aria-label"> {
  value: string;
  successMessage?: string;
  IconProps?: IconPropsType;
}

export const CopyToClipboard = (props: CopyToClipboardProps) => {
  const { value, successMessage, IconProps, ...rest } = props;
  const { copyToClipboard } = useCopyToClipboard();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    void copyToClipboard(value, successMessage);
  };

  return (
    <IconButton
      onClick={handleClick}
      aria-label="Copy to clipboard"
      variant="quaternary"
      {...rest}
    >
      <Icon icon={faClipboard} {...IconProps} />
    </IconButton>
  );
};
